import ExtendedEventDetailsMapper from './extended-event-details-mapper';
import EventCompetitorsModel from '../event-competitors/event-competitors-model';
import LiveModel from '../live/live-model';
import MarketModel from '../market/market-model';

const ExtendedEventDetailsModel = {
    mapper: ExtendedEventDetailsMapper,

    booked: {
        type: Boolean,
    },

    categoryName: {
        type: String,
    },

    currentSeasonId: {
        type: String,
    },

    favorite: {
        type: Boolean,
    },

    frozen: {
        type: Boolean,
    },

    id: {
        type: String,
    },

    leagueName: {
        type: String,
    },

    live: {
        type: Boolean,
    },

    liveStatistics: {
        model: LiveModel,
        type: Object,
    },

    markets: {
        modelContext: {
            eventId: 'id',
        },
        model: MarketModel,
        type: Array,
    },

    mbn: {
        type: Number,
    },

    playerNames: {
        type: Object,
    },

    programCode: {
        type: Number,
    },

    seasonRefId: {
        type: String,
    },

    sportTypeRefId: {
        type: String,
    },

    startedAt: {
        type: Number,
    },

    teams: {
        model: EventCompetitorsModel,
        type: Object,
    },
};

export default ExtendedEventDetailsModel;
